import(/* webpackMode: "eager" */ "/workspace/src/app/privacy-policy/page.tsx");
